// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hiLDTboAEnv_RIjSVera{background-color:rgba(0,0,0,0) !important;padding:12px 0 !important}ul .hiLDTboAEnv_RIjSVera{padding-top:0 !important}", "",{"version":3,"sources":["webpack://./src/components/SidebarSubOptions/FooterNote.module.scss"],"names":[],"mappings":"AAAA,sBACE,yCAAA,CACA,yBAAA,CAGF,yBACE,wBAAA","sourcesContent":[".footerNote {\n  background-color: transparent !important;\n  padding: 12px 0 !important;\n}\n\n:global(ul) .footerNote {\n  padding-top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerNote": "hiLDTboAEnv_RIjSVera"
};
export default ___CSS_LOADER_EXPORT___;
